<template>
  <div id="income-summary">
    <div>
      <h1>Current Annual Revenue</h1>
    </div>
    <div class="form-section">
      <summary-col>
        <h3>Mortgages</h3>
      </summary-col>
      <data-col>
        <data-row>
          <label>Monthly Mortgage Income</label>
          <div class="data-summary-wrapper">
          <div class="data-summary">{{ mortgageIncome }}</div>
          </div>
        </data-row>
      </data-col>
    </div>
    <div class="form-section">
      <summary-col>
        <h3>Protection</h3>
      </summary-col>
      <data-col>
        <data-row>
          <label>Monthly Protection Income</label>
          <div class="data-summary-wrapper">
          <div class="data-summary">{{ lifeIncome }}</div>
          </div>
        </data-row>
      </data-col>
    </div>
    <div class="form-section">
      <summary-col>
        <h3>Buildings & Contents</h3>
      </summary-col>
      <data-col>
        <data-row>
          <label>Monthly Building & Contents Income</label>
          <div class="data-summary-wrapper">
          <div class="data-summary">{{ binsIncome }}</div>
          </div>
        </data-row>
      </data-col>
    </div>
    <div class="form-section">
      <summary-col>
        <h3>Estimated Monthly Overheads</h3>
      </summary-col>
      <data-col>
        <data-row>
          <label>Total Monthly Overheads</label>
          <div class="data-summary-wrapper">
          <div class="data-summary">{{ overheads }}</div>
          </div>
        </data-row>
        <data-row>
          <label>Lapse Provisions @ {{lapseRate}}% <img class="img-help" src="../assets/icons/help-pink.svg" @click="toggleHelp"/></label>
          <div class="data-summary-wrapper">
          <div class="data-summary">{{ currentLapseProvisions }}</div>
          </div>
          <Transition name="fade">
            <div class="help-text" v-if="showHelp" >This figure assumes 25% of protection policies are lapsed, resulting in commission clawback.</div>
          </Transition>
        </data-row>
      </data-col>
    </div>
    <div class="form-section">
      <summary-col>
        <h3>Annual Summary</h3>
      </summary-col>
      <data-col>
        <data-row>
          <label>Total Income</label>
          <div class="data-summary-wrapper">
          <div class="data-summary">{{ annualIncome }}</div>
          </div>
        </data-row>
        <data-row>
          <label>Total Costs</label>
          <div class="data-summary-wrapper">
          <div class="data-summary">{{ annualCosts  }}</div>
          </div>
        </data-row>
        <data-row>
          <label>Total Lapsed Policies</label>
          <div class="data-summary-wrapper">
          <div class="data-summary">{{ annualLapseProvisions  }}</div>
          </div>
        </data-row>
        <data-row>
          <label>Profit</label>
          <div class="data-summary-wrapper">
          <div class="data-summary">{{ annualProfit  }}</div>
          </div>
        </data-row>
      </data-col>
    </div>
    <div id="form-footer">
      <div class="button-wrapper back-button-wrapper">
        <BtnBack title="Back"/>
      </div>
      <div class="button-wrapper next-button-wrapper">
        <BtnNext title="Next" currentPage="revenue-summary"  />
      </div>
    </div>
  </div>
</template>

<script>
var formatter = new Intl.NumberFormat('en-GB', {
  style: 'currency',
  currency: 'GBP',
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});


import BtnNext from './BtnNext.vue'
import BtnBack from './BtnBack.vue'
export default {
  data () {
    return {
      showHelp: false
    }
  },
  props: {
  },
  methods:{
    toggleHelp() {
      this.showHelp = !this.showHelp;
   }
  },
  computed: {
      lapseRate:{
          get () {
            return this.$store.state.lapseRate
          }
      },
      mortgageIncome: {
        get () {
          return formatter.format(this.$store.getters.currentMortgageIncome)
        }
      },
      lifeIncome: {
        get () {
          return formatter.format(this.$store.getters.currentLifeIncome)
        }
      },
      binsIncome: {
        get () {
          return formatter.format(this.$store.getters.currentBinsIncome)
        }
      },
      overheads: {
        get (){
          return formatter.format(this.$store.getters.totalOverheads)
        }
      },
      currentLapseProvisions: {
        get (){
          return formatter.format(this.$store.getters.currentLapseProvisions)
        }
      },
      annualCosts: {
        get () {
          return formatter.format(this.$store.getters.currentAnnualCosts)
        }
      },
      annualLapseProvisions: {
        get () {
          return formatter.format(this.$store.getters.currentAnnualLapseProvisions)
        }
      },
      annualIncome: {
        get () {
          return formatter.format(this.$store.getters.currentAnnualIncome)
        }
      },
      annualProfit: {
        get () {
          return formatter.format(this.$store.getters.currentAnnualProfit)
        }
      }
  },
  components: {
    BtnNext,
    BtnBack
  }
}
</script>
